// extracted by mini-css-extract-plugin
export var assigneeBadge = "_no-0";
export var assigneeDetails = "_no-1";
export var assigneeInfo = "_no-2";
export var dropdownContainer = "_no-4";
export var dropdownImage = "_no-5";
export var editAssigneeInfo = "_no-3";
export var editAssigneeModalContainer = "_no-6";
export var hidden = "_no-8";
export var input = "_no-7";